export default {
	namespaced: true,
	state: {
		isNewPerson: false
	},
	getters: {
		getIsNewPerson(state) {
			return state.isNewPerson
		}
	},
	mutations: {
		setIsNewPerson(store, payload) {
			store.isNewPerson = payload
		}
	}
}
